class Hamburger {
    constructor() {
        this.$hamburger = $('.js-hamburger')
        this.$menu = $('.js-menu')
        this.$menuList = $('.header__menuList')
    }

    toggle(){
        const breakpoint2 = window.matchMedia( '(max-width:1024px)' );
        let hamburger;
        const classCheck = () => {
        if ( breakpoint2.matches === true ) {
            this.$menuList.addClass('js-menu');
            this.$hamburger.on('click', () => {
                this.$menuList.toggleClass('active');
                this.$hamburger.toggleClass('active');
            })
        } else if ( breakpoint2.matches === false ) {
            this.$menuList.removeClass('js-menu');
            if ( hamburger !== undefined ) hamburger.destroy( true, true );
            return;
        }
    };

    breakpoint2.addListener(classCheck);
    classCheck();
    }
    
}

export default Hamburger